export default "__VITE_ASSET__BpcaT0ue__"